import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="bg-background-50 py-20 md:py-28">
      <div className="w-full px-6 md:px-10 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-3">
            Explore Product Categories
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            Browse trending products across all major categories sourced from China suppliers.
          </p>
        </div>

        {/* Category Cards */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
          {categories.map((cat, i) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative bg-background-100 rounded-xl p-4 flex flex-col items-center justify-center gap-2.5 hover:bg-accent-100/60 border border-transparent hover:border-accent-200/60 transition-all duration-300 cursor-pointer min-h-[100px]"
            >
              <div className="w-9 h-9 rounded-lg bg-background-200/60 flex items-center justify-center group-hover:bg-accent-200/60 transition-colors duration-300">
                <i className={`${cat.icon} text-foreground-600 group-hover:text-accent-700 text-base`}></i>
              </div>
              <span className="text-foreground-800 text-xs font-medium text-center whitespace-nowrap leading-tight">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}